import { Box, Button, Grid, MenuItem, Select } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ReqField } from 'src/components/CustomComponents/CustomLoader';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import PageContainer from 'src/components/container/PageContainer';
import TextInputs from 'src/components/inputs/TextInputs';
import DashboardCard from 'src/components/shared/DashboardCard';
import { useMain } from '../hooks/useMain';
import SelectInputs from 'src/components/inputs/SelectInputs';


const initialValue = {
  date: getCurrentDateInFormat(),
  typeOfExpense: '',
  others: '',
  staffId: '',
  amountPaid: 0,
  modeOfPayment: 'Cash',
  recipientName: '',
  description: '',
};

const expensestype = ['Salary', 'Staff Advance', 'Others'];
const paymentmode = ['Cash', 'Credit/Debit Card', 'Paytm', 'PhonePe', 'Gpay'];

const AddExpenses = () => {
  const [formData, setFormData] = useState(initialValue);
  const [staff, setStaff] = useState([]);

  const [typeData, setTypeData] = useState([]);
  const [loading, setLoading] = useState(false);

  const { createExpense, activeBranchId, setShowMessage, fetchAllExpenseType, getBranch } =
    useMain();

  const handleChange = (e) => {
    const { value, name } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async () => {
    const { date, typeOfExpense, amountPaid, modeOfPayment, recipientName } = formData;
    if (date === '') return setShowMessage({ message: 'Date is required', messageType: 'error' });
    if (typeOfExpense === '')
      return setShowMessage({ message: 'Expense Type is required', messageType: 'error' });
    if (amountPaid == 0)
      return setShowMessage({ message: 'Amount is required', messageType: 'error' });
    if (modeOfPayment === '')
      return setShowMessage({ message: 'Mode of payment is required', messageType: 'error' });
    // if (recipientName === '')
    //   return setShowMessage({ message: 'Reciept Name is required', messageType: 'error' });
    try {
      setLoading(true);
      const res = await createExpense({
        ...formData,
        branchDetails: activeBranchId,
      });
      if (res.statusCode === 200) {
        setShowMessage({
          message: res.message || 'Expense has been created successfully',
          messageType: 'success',
        });
        setFormData(initialValue);
      } else {
        setShowMessage({ message: res.message || 'Something went wrong', messageType: 'error' });
      }
    } catch (error) {
      setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
    } finally {
      setLoading(false);
      getData();
    }
  };

  const getData = async () => {
    try {
      const res = await fetchAllExpenseType(activeBranchId);
      if (res.statusCode === 200) {
        setTypeData(res.data || []);
      }
    } catch (error) {}
  };

  const getAllData = async () => {
    try {
      const res = await getBranch(activeBranchId);
      setStaff(res?.data?.staffs || []);
    } catch (error) {}
  };

  useEffect(() => {
    if (activeBranchId) {
      getAllData();
      getData();
    }
    return () => {
      setTypeData([]);
      setStaff({});
    };
  }, [activeBranchId]);

  // This logic disables the mouse wheel event
  useEffect(() => {
    const handleWheel = (e) => {
      if (document.activeElement.type === 'number') {
        document.activeElement.blur();
      }
    };

    window.addEventListener('wheel', handleWheel);
    return () => {
      window.removeEventListener('wheel', handleWheel);
    };
  }, []);

  return (
    <PageContainer title="Create Expense" description="this is add expenses">
      <DashboardCard title={'Create Expense'}>
        <Box style={{ marginTop: '10px' }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <TextInputs
                title={'Date'}
                name={'date'}
                value={formData?.date}
                handleChange={handleChange}
                type={'date'}
                max={new Date().toISOString().split('T')[0]}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <div style={{ marginBottom: '6px', fontWeight: 'bold' }}>
                Type of Expenses <ReqField />
              </div>
              <Select
                name="typeOfExpense"
                value={formData?.typeOfExpense}
                onChange={handleChange}
                fullWidth
              >
                {typeData.map((type) => (
                  <MenuItem key={type} value={type}>
                    {type}
                  </MenuItem>
                ))}
                {expensestype.map((type) => (
                  <MenuItem key={type} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            {formData.typeOfExpense === 'Others' ? (
              <Grid item xs={12} md={4}>
                <TextInputs
                  title={'Others'}
                  name={'others'}
                  value={formData?.others}
                  handleChange={handleChange}
                  type={'text'}
                />
              </Grid>
            ) : formData.typeOfExpense === 'Staff Advance' ? (
              <Grid item xs={12} md={4}>
                <SelectInputs
                  name={'staffId'}
                  value={formData?.staffId}
                  title={'Staff'}
                  handleChange={handleChange}
                  options={staff}
                  optionValue={'_id'}
                  optionTitle={'name'}
                />
              </Grid>
            ) : (
              ''
            )}
            <Grid item xs={12} md={4}>
              <TextInputs
                title={'Amount Paid'}
                name={'amountPaid'}
                value={formData?.amountPaid}
                handleChange={handleChange}
                type={'number'}
                min={'0'}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <div style={{ marginBottom: '6px', fontWeight: 'bold' }}>
                Payment Mode <ReqField />
              </div>
              <Select
                name="modeOfPayment"
                value={formData?.modeOfPayment}
                onChange={handleChange}
                fullWidth
              >
                {paymentmode?.map((type) => (
                  <MenuItem key={type} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs={12} md={4}>
              <TextInputs
                title={'Receipt Name'}
                name={'recipientName'}
                value={formData?.recipientName}
                handleChange={handleChange}
                type={'text'}
                required={false}
                placeholder={"Receipt"}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextInputs
                required={false}
                title={'Description'}
                name={'description'}
                value={formData?.description}
                handleChange={handleChange}
                type={'text'}
                placeholder={"Text..."}
              />
            </Grid>
          </Grid>
        </Box>
        {loading ? (
          <ShowLoader />
        ) : (
          <div style={{ width: '200px', margin: '3rem auto' }}>
            <Button
              variant="contained"
              fullWidth
              color="primary"
              target="_blank"
              sx={{
                background: '#6174DD',
              }}
              onClick={handleSubmit}
            >
              Create Expense
            </Button>
          </div>
        )}
      </DashboardCard>
    </PageContainer>
  );
};

export default AddExpenses;

// Function to get the current date in a specific format
function getCurrentDateInFormat() {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
